import { Stack, Typography } from "@mui/material";
import useLocales from "src/hooks/useLocales";
import useResponsive from "src/hooks/useResponsive";

// ----------------------------------------------------------------------

export const DemoTitle = () => {
	const isMobile = useResponsive("down", "sm");
	const { translate } = useLocales();

	return (
		<Stack sx={{ zIndex: 100, px: { xl: 40, lg: 30, md: 12, sm: 10, xs: 6 }, mt: 4 }} gap={2}>
			<Typography color='white' variant={isMobile ? "h2" : "h1"}>
				{"Vumi Finlink Demo"}
			</Typography>
			<Typography
				color='#919EAB'
				variant={isMobile ? "body2" : "body1"}
				maxWidth={590}
				sx={{ ml: 0.5 }}
			>
				{translate("demo.title_description")}
			</Typography>
		</Stack>
	);
};

export default DemoTitle;
